import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import PriceList from './pages/PriceList';
import EstimateCost from './pages/EstimateCost';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppFab from './components/WhatsAppFab';
import AdminFab from './components/AdminFab';
import { Toaster } from './components/ui/sonner';

// Admin
import { AuthProvider } from './admin/AuthContext';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminConfig from './admin/AdminConfig';
import AdminBanners from './admin/AdminBanners';
import AdminCatalog from './admin/AdminCatalog';
import AdminAbout from './admin/AdminAbout';
import AdminContact from './admin/AdminContact';
import AdminArticles from './admin/AdminArticles';
import AdminUsers from './admin/AdminUsers';

function PublicChrome({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith('/admin');
  if (isAdmin) return children;
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
      <WhatsAppFab />
      <AdminFab />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <PublicChrome>
            <Routes>
              {/* Public site */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:slug" element={<ArticleDetail />} />
              <Route path="/akses-data" element={<PriceList />} />
              <Route path="/estimasi-biaya" element={<EstimateCost />} />
              <Route path="/contact" element={<Contact />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="config" element={<AdminConfig />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="catalog" element={<AdminCatalog />} />
                <Route path="articles" element={<AdminArticles />} />
                <Route path="about" element={<AdminAbout />} />
                <Route path="contact" element={<AdminContact />} />
                <Route path="users" element={<AdminUsers />} />
              </Route>
            </Routes>
          </PublicChrome>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
